export default __webpack_public_path__ + "static/media/plain-sticker-g.362f7380.png";